<template>
    <q-page class="q-pa-md">
        <!-- DIALOG PARA MOSTRAR EL PDF -->
        <q-dialog v-model="dialogPdf" maximized transition-show="slide-up" transition-hide="slide-down">
            <visor-pdf @closeDialog="CierraDialogPdf" @closeDialogTimbrado="CierraDialogPdfTimbrado"></visor-pdf>
        </q-dialog>
        <div class="row q-pt-md q-col-gutter-md">
            <div class=" col-12">
                <!-- TABLA DE COMPROBANTES -->
                <q-table title="Facturas" :data="dataComprobantes" :columns="columns" row-key="_id"
                    :rows-per-page-options="[10]" :filter="filter" class="shadow-1">
                    <template v-slot:top-right>
                        <q-input color="primary" v-model="fehaIMasked" class="q-my-md q-mr-md" label="Fecha Inicial"
                            name="event" outlined dense>
                            <template v-slot:prepend>
                                <q-icon name="event" color="primary" />
                            </template>
                            <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                                <q-date v-model="fechaI" @input="UltimoDiaMes">
                                    <div class="row items-center justify-end">
                                        <q-btn v-close-popup label="Ok" color="primary" flat />
                                    </div>
                                </q-date>
                            </q-popup-proxy>
                        </q-input>
                        <q-input color="primary" v-model="fechaFMasked" label="Fecha Final" outlined dense
                            class="q-my-md q-mr-md">
                            <template v-slot:prepend>
                                <q-icon name="event" color="primary" />
                            </template>
                            <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                                <q-date v-model="fechaF">
                                    <div class="row items-center justify-end">
                                        <q-btn v-close-popup label="Ok" color="primary" flat />
                                    </div>
                                </q-date>
                            </q-popup-proxy>
                        </q-input>
                        <q-btn outline label="Consultar" class="q-my-md  " color="primary" @click="GetComprobantes"
                            icon="mdi-refresh" no-caps>
                        </q-btn>
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="serie" :props="props" @click="VerPdf(props.row)">{{ props.row.serie }}</q-td>
                            <q-td key="folio" :props="props" @click="VerPdf(props.row)">
                                <q-badge :color="colorComprobante(props.row.estatus)" rounded>
                                    {{ props.row.folio }}
                                </q-badge>
                            </q-td>
                            <q-td key="fecha" :props="props" @click="VerPdf(props.row)">{{ FormatDate(props.row.fecha)
                                }}</q-td>
                            <q-td key="rfc" :props="props" @click="VerPdf(props.row)">{{ props.row.rfc }}</q-td>
                            <q-td key="nombre" :props="props" @click="VerPdf(props.row)">{{ props.row.nombre }}</q-td>
                            <q-td key="subTotal" :props="props" @click="VerPdf(props.row)">{{
                                FormatCurrency(props.row.subTotal) }}</q-td>
                            <q-td key="total" :props="props" @click="VerPdf(props.row)">{{
                                FormatCurrency(props.row.total) }}</q-td>
                            <q-td key="moneda" :props="props" @click="VerPdf(props.row)">{{ props.row.moneda }}</q-td>
                            <q-td key="formaPago" :props="props" @click="VerPdf(props.row)">{{ props.row.formaPago
                                }}</q-td>
                            <q-td key="metodoPago" :props="props" @click="VerPdf(props.row)">{{ props.row.metodoPago
                                }}</q-td>
                            <q-td key="solicitudCancelacion" :props="props" @click="VerPdf(props.row)">{{
                                props.row.solicitudCancelacion }}</q-td>
                            <q-td key="oc" :props="props" @click="VerPdf(props.row)">{{ props.row.oc }}</q-td>
                            <q-td key="folioFiscal" :props="props">{{ props.row.folioFiscal }}</q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from 'axios'
import { format } from 'date-fns';
import { parse } from 'date-fns';
import { endOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';
import { QSpinnerCube } from 'quasar';
import moment from 'moment';
import VisorPdf from '../../PDF/VisorPdf.vue'

export default {
    components: {
        VisorPdf,
    },
    data() {
        return {
            fechaI: new Date(),
            fechaF: new Date(),
            filter: '',
            columns: [
                // { name: 'actions', align: 'left', label: 'Acciones', field: 'actions' },
                { name: 'serie', align: 'left', label: 'Serie', field: 'serie', sortable: true },
                { name: 'folio', align: 'left', label: 'Folio', field: 'folio', sortable: true },
                { name: 'fecha', align: 'left', label: 'Fecha', field: 'fecha', sortable: true },
                { name: 'rfc', align: 'left', label: 'RFC', field: 'rfc', sortable: true },
                { name: 'nombre', align: 'left', label: 'Nombre', field: 'nombre', sortable: true },
                { name: 'subTotal', align: 'right', label: 'SubTotal', field: 'subTotal', sortable: true },
                { name: 'total', align: 'right', label: 'Total', field: 'total', sortable: true },
                { name: 'moneda', align: 'left', label: 'Moneda', field: 'moneda', sortable: true },
                { name: 'formaPago', align: 'left', label: 'Forma de Pago', field: 'formaPago', sortable: true },
                { name: 'metodoPago', align: 'left', label: 'Método de Pago', field: 'metodoPago', sortable: true },
                { name: 'solicitudCancelacion', align: 'left', label: 'Solicitud de Cancelación', field: 'solicitudCancelacion', sortable: true },
                { name: 'oc', align: 'left', label: 'OC', field: 'oc', sortable: true },
                { name: 'folioFiscal', align: 'left', label: 'Folio Fiscal', field: 'folioFiscal', sortable: true },
            ],
            dialogComprobante: false,
            dialogPdf: false,
            //REMISIONES
            dialogRemision: false,

            dialogCancelacion: false,
            dialogValidaEstatus: false,

            //ADDENDA
            dialogAddenda: false,
        }
    },
    computed: {

        dataComprobantes() {
            return this.$store.state.auth.listFacturaStore;
        },

        fehaIMasked() {
            moment.locale('es-mx');
            return this.fechaI ? moment(this.fechaI).format('DD/MMMM/yyyy') : ''
        },

        fechaFMasked() {
            moment.locale('es-mx');
            return this.fechaF ? moment(this.fechaF).format('DD/MMMM/yyyy') : ''
        },

    },
    created() {
    },
    methods: {
        async GetComprobantes() {
            this.$q.loading.show({
                spinner: QSpinnerCube,
                spinnerColor: 'primary',
                spinnerSize: 140,
                message: 'Consultando, esprere..',
            })
            try {
                let fechaI_ = new Date(this.fechaI);
                let fechaF_ = new Date(this.fechaF);
                let fechaI = format(fechaI_, "yyyy-MM-dd");
                let fechaF = format(fechaF_, "yyyy-MM-dd");
                let response = await axios.get('https://api-beta-erp.contago.com.mx/api/Comprobantes/GetComprobanteAsync/erp_IIA040805DZ4/comprobantes_emitidos/FACTURA/' + fechaI + '/' + fechaF);
                const x = response.data;
                this.$store.state.auth.listFacturaStore = x;
                this.$q.loading.hide()
            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        },

        UltimoDiaMes() {
            let fechaI = this.fechaI;
            fechaI = fechaI.replaceAll('/', '-');
            const fecha = parse(fechaI, 'yyyy-MM-dd', new Date());
            const ultimoDiaDelMes = endOfMonth(fecha);
            this.fechaF = ultimoDiaDelMes;
        },

        async VerPdf(item) {
            let id = item._id;
            let empresa = { ...this.$store.state.auth.empresaStore };
            let color = empresa.color;
            let folioFiscal = item.folioFiscal;
            try {
                this.$store.state.auth.vistaPreviaStore = {
                    comprobante: null,
                    color: color,
                    logo: '',
                    rfc: 'SCA900316JP0',
                    folioFiscal: item.folioFiscal,
                    tipoComprobanteInterno: 'FACTURA'
                };
                this.dialogPdf = true;
            } catch (error) {
                console.log(error)
            }
        },

        CierraDialog() {
            this.dialogComprobante = false;
        },

        CierraDialogPdf() {
            this.dialogPdf = false;
        },

        CierraDialogPdfTimbrado() {
            this.dialogPdf = false;
        },

        colorComprobante(item) {
            var color = '';
            switch (item) {
                case 'Vigente':
                    color = 'green-14';
                    break;
                case 'Cancelado':
                    color = 'red-10';
                    break;
            }
            return color;
        },

        FormatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },

        FormatDate(value) {
            let fecha = new Date(value);
            let dia = fecha.getDate();
            let mes = fecha.toLocaleString('es-ES', { month: 'long' }); // Obtener el mes en formato de letra
            let anio = fecha.getFullYear();
            let formatoDeseado = `${dia}-${mes}-${anio}`;
            return formatoDeseado;
        },



        async OpenDialogCancelacion(item) {
            let ObjCancelacion = {
                folioFiscal: item.folioFiscal,
                rfcEmisor: this.token.rfc,
                rfcReceptor: item.rfc,
                total: this.FormatCurrency(item.total),
                ventana: "Facturacion",
                nombreReceptorr: item.nombre,
                folio: item.serie + " " + item.folio,
            }
            this.$store.state.auth.cancelacionStore = { ...ObjCancelacion }
            // console.log(ObjCancelacion);
            this.dialogCancelacion = true;
        },

        async ValidaEstatusSat(item) {
            let ObjValida = {
                rfc: item.rfc,
                nombre: item.nombre,
                rfcEmisor: this.token.rfc,
                rfcReceptor: item.rfc,
                total: item.total,
                folioFiscal: item.folioFiscal,
                tipoComprobante: "I",
                tipoComprobanteInterno: "FACTURA",
                comprobante: item,
            };
            this.$store.state.auth.validaEstatusStore = { ...ObjValida }
            this.dialogValidaEstatus = true;
        },


    },
}
</script>

<style>
/* .borde-personalizado .q-field__control {
    border: 2px solid #0094CA;
    border-radius: 4px;
} */
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}

.q-field--outlined .q-field__control:after {
    border-radius: inherit;
    border: 1px solid #0094CA;
}

.q-field--dense .q-field__label {
    color: #0094CA;
}
</style>